<interacta-user-notification [notification]="notification()">
    @if (asActivityPost(); as activity) {
        <div class="mt-8 flex flex-wrap items-center gap-x-12 gap-y-4">
            @let assignee = activity.assignee ?? emptyMemberPlaceholder;
            <interacta-member
                [compactUserName]="
                    assignee.innerId !== emptyMemberPlaceholder.innerId
                "
                [fontWeight]="'regular'"
                [member]="assignee"
                [memberClickBehavior]="'none'"
                [size]="'extra-small'"
            />

            @if (activity.expectedStart || activity.expectedEnd) {
                <interacta-activity-date-container [activity]="activity" />
            }

            @if (activity.priority != null) {
                <interacta-priority
                    [fullLabel]="false"
                    [priority]="activity.priority"
                    [size]="'extra-small'"
                />
            }
        </div>
    }
</interacta-user-notification>
